import { useAtomValue } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { LocalStorageKey } from ".";
import { getLocale } from "../../helpers/locale";

type LanguagePreference = "default" | "ko" | "en" | "ja" | "th" | "vi";

export const DEFAULT_LANGUAGE_PREFERENCE: LanguagePreference = "default";

export const systemLanguageAtom = atomWithStorage<string>(
  LocalStorageKey.Language,
  DEFAULT_LANGUAGE_PREFERENCE,
  {
    getItem(key: string, initialValue: string): string {
      return localStorage.getItem(key) ?? initialValue;
    },
    setItem(key: string, newValue: string) {
      localStorage.setItem(key, newValue);
    },
    removeItem: localStorage.removeItem,
  },
  { getOnInit: true }
);

type Preference = {
  language: string;
};

export const usePreference = (): Preference => {
  let language = useAtomValue(systemLanguageAtom);
  if (language === DEFAULT_LANGUAGE_PREFERENCE) {
    language = getLocale();
  }
  return {
    language: language,
  };
};
